export const getGridColumns = (showSecurityName: boolean, showTotal: boolean): string => {
	if (showSecurityName && showTotal) {
		return '1fr auto auto';
	}
	if (showSecurityName) {
		return 'auto auto';
	}
	if (showTotal) {
		return 'auto auto';
	}
	return 'auto';
};
